module.exports = __webpack_public_path__ + "static/media/banner_1.8e04a1c5.png";